module.exports = __webpack_public_path__ + "img/more.09fbda3c.svg";